/**
 * @module utils/array
 * @category Utilidades
 * @summary Módulo de utilidades para manipulação de _arrays_.
 *
 * @description
 * Expõe funções de utilidades para manipulação de _arrays_.
 */

/**
 * Busca um elemento de um _array_ de objetos a partir de um filtro de busca.
 * @function
 * @param {Array<object>} arr - _array_ com os elementos.
 * @param {string} propName - Nome da propriedade utilizada como filtro de
 * busca.
 * @param {*} propValue - Valor da propriedade utilizada como filtro de busca.
 * @returns {object} Primeiro elemento do _array_ cujo filtro de busca foi
 * satisfeito.
 */
export const findByObjectProp = function(arr, propName, propValue) {
  return (arr || []).find(function(value) {
    return value && value[propName] === propValue;
  });
};

/**
 * Gera um _array_ contendo números inteiros em um intervalo `[a, b)`.
 * @function
 * @param {number} a - Valor inicial do intervalo.
 * @param {number} b - Valor final do intervalo. Caso não seja informado, o
 * parâmetro `a` equivale ao fim do intervalo iniciando-se em `0`.
 * @param {number} [c=1] - Valor do passo entre os elementos do intervalo.
 * @returns {Array<number>} _Array_ com os números dentro de um intervalo.
 */
export const range = function(a, b, c = 1) {
  let start = 0;
  let end = a;
  let step = c;

  if (b !== undefined) {
    start = end;
    end = b;
  }

  const array = [];

  for (let i = 0; i < end; i++) {
    const value = start + i * step;

    if (value >= end) {
      break;
    }

    array.push(value);
  }

  return array;
};

export default { findByObjectProp, range };
